import { Table } from "components";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import {  RegisteredDcddUserProps } from "modules/user_management/dcdd_user/users/state/actionType";

interface Props {
  dcddUserData: RegisteredDcddUserProps[];
}
const DcddUserTable: React.FC<Props> = ({ dcddUserData }) => {
  const downloadExcel = (data: any[]) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((field) => `<td>${row[field] ?? ""}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const tableHTML = `
    <table>
      <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
      <tbody>${rows}</tbody>
    </table>`;

    const blob = new Blob(
      [
        `\uFEFF<html><head><meta charset="UTF-8"></head><body>${tableHTML}</body></html>`,
      ],
      { type: "application/vnd.ms-excel" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "dcdd_users.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <Table
        headers={["Report", "New Register", "Dcdd Users"]}
        data={dcddUserData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <button
            className="border px-3 py-2 bg-primary-500 mx-2 rounded-md hover:bg-primary-800 text-primary-100 hover:text-white hover:shadow-md"
            onClick={() => downloadExcel(dcddUserData)}
          >
            Download Excel
          </button>
        }
      />
    </>
  );
};

export default DcddUserTable;
